"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRequestWithoutElementsPayloadCheck = exports.makeRequestWithElementsPayloadCheck = void 0;

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

class NoElementsError extends _extendableBuiltin(Error) {
  constructor(message) {
    super(message);
    this.name = 'NoElementsError';
  }

}

const makeRequestWithElementsPayloadCheck = (elements, method, url, payload, config = {}) => {
  if (elements !== null && elements !== void 0 && elements.hasElement(payload)) {
    return elements.client[method](url, payload, config);
  }

  let errorMessageStart = 'Elements not initialized.';

  if (elements) {
    errorMessageStart = 'Element not found in payload.';
  }

  throw new NoElementsError(`${errorMessageStart} Use a regular HTTP client if no elements are needed.`);
};

exports.makeRequestWithElementsPayloadCheck = makeRequestWithElementsPayloadCheck;

const makeRequestWithoutElementsPayloadCheck = (elements, method, url, config = {}) => {
  if (elements) {
    return elements.client[method](url, config);
  }

  throw new NoElementsError('Elements not initialized. Use a regular HTTP client if no elements are needed.');
};

exports.makeRequestWithoutElementsPayloadCheck = makeRequestWithoutElementsPayloadCheck;